import { forwardRef, SyntheticEvent, useContext } from 'react'
import { useSearchParams } from 'react-router'
import { FolderOutlined, PersonOutlined } from '@mui/icons-material'
import { ButtonBase, ButtonBaseProps, Chip, Grid, Tab, Tabs } from '@mui/material'

import AccountsContext from '../context'
import useStyles from '../index.styles'

export const TabButton = forwardRef((props: ButtonBaseProps, ref: React.ForwardedRef<HTMLButtonElement | null>) => {
  const classes = useStyles
  const { folder, folderTree } = useContext(AccountsContext)

  if (folder && folderTree && folderTree[folder.id] && folderTree[folder.id].children) {
    const folderCount = folderTree[folder.id].children?.length
    const count = props.id !== 'tab-people' ? folderCount : folder?.usercount

    return (
      <ButtonBase {...props} ref={ref} data-testid="tab-button">
        {props.children}
        <Chip label={count} size="small" sx={classes.tabChip} />
      </ButtonBase>
    )
  }
  return null
})

interface ITabsComponentProps {
  tabIndex: string
}

const TabsComponent = (props: ITabsComponentProps) => {
  const { tabIndex } = props

  const classes = useStyles
  const { folder, folderTree } = useContext(AccountsContext)
  const [, setSearchParams] = useSearchParams()

  const folderCount = folder && folderTree && folderTree[folder.id] ? (folderTree[folder.id].children?.length ?? 0) : 0

  const handleTabChange = (_event: SyntheticEvent, newValue: number) => {
    setSearchParams({ tab: String(newValue) })
  }

  if (folder && folderTree && folderTree[folder.id] && folderTree[folder.id].children)
    return (
      <Tabs value={tabIndex} onChange={handleTabChange} sx={classes.tabs}>
        {folder.type === '' && (
          <Tab
            label="Accounts"
            id="tab-accounts"
            value="accounts"
            aria-label={`Accounts (${folderCount})`}
            icon={<FolderOutlined />}
            iconPosition="start"
            component={TabButton}
            sx={classes.tabButtonBaseRoot}
          />
        )}
        {folder.type === 'Client Company' && (
          <Tab
            label="Programs"
            id="tab-programs"
            value="programs"
            aria-label={`Programs (${folderCount})`}
            icon={<FolderOutlined />}
            iconPosition="start"
            component={TabButton}
            sx={classes.tabButtonBaseRoot}
          />
        )}
        {folder.type === 'Program' && (
          <Tab
            label="Participants"
            id="tab-participants"
            value="participants"
            aria-label={`Participants (${folderCount})`}
            icon={<FolderOutlined />}
            iconPosition="start"
            component={TabButton}
            sx={classes.tabButtonBaseRoot}
          />
        )}
        <Tab
          label="People"
          id="tab-people"
          value="people"
          aria-label={`People (${folder.usercount})`}
          icon={<PersonOutlined />}
          iconPosition="start"
          component={TabButton}
          sx={classes.tabButtonBaseRoot}
        />
      </Tabs>
    )
  return <Grid />
}

export default TabsComponent
